<template>
  <div class="card border-0 rounded shadow">
    <div class="card-body"><InvoiceSettings /></div>
  </div>
</template>
<script>
import InvoiceSettings from "./InvoiceSettings.vue";
export default {
  components: {
    InvoiceSettings
  },
  data() {
    return {};
  }
};
</script>
